export default {
      id: "circle-external-technodom-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#circle-external-technodom-usage",
      toString: function () {
        return this.url;
      }
    }